(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elavie-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initFaqAccordion(container) {
    var items = container.querySelectorAll('.faq-accordion__item');
    items.forEach(function(item) {
      if (item.dataset.initialized) return;
      item.dataset.initialized = 'true';
      var trigger = item.querySelector('.faq-accordion__item-title');
      var content = item.querySelector('.faq-accordion__item-description');
      if (!trigger || !content) return;
      content.style.overflow = 'hidden';
      if (item.classList.contains('is-open')) {
        content.style.height = 'auto';
        content.style.height = content.scrollHeight + 'px';
        content.style.paddingBottom = '20px';
      } else {
        content.style.height = '0px';
        content.style.paddingBottom = '0px';
      }
      trigger.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function(other) {
          if (other === item) return;
          var oc = other.querySelector('.faq-accordion__item-description');
          other.classList.remove('is-open');
          if (oc) { oc.style.height = '0px'; oc.style.paddingBottom = '0px'; }
        });
        if (isOpen) {
          item.classList.remove('is-open');
          content.style.height = '0px';
          content.style.paddingBottom = '0px';
        } else {
          item.classList.add('is-open');
          content.style.height = 'auto';
          var full = content.scrollHeight + 'px';
          content.style.height = '0px';
          requestAnimationFrame(function() {
            content.style.height = full;
            content.style.paddingBottom = '20px';
          });
        }
      });
    });
  }
  document.querySelectorAll('.faq-accordion').forEach(function(section) { initFaqAccordion(section); });
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList && event.target.classList.contains('faq-accordion')) {
      initFaqAccordion(event.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-geo-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.egb').forEach(function(bar) {
    var textEl = bar.querySelector('.egb__text');
    var flagEl = bar.querySelector('.egb__flag');
    var prefix = bar.getAttribute('data-prefix') || 'Delivering to';
    var fallback = bar.getAttribute('data-fallback') || 'Worldwide Shipping Available';

    function flagEmoji(iso) {
      if (!iso || iso.length !== 2) return '';
      var A = 0x1F1E6;
      return String.fromCodePoint(A + iso.toUpperCase().charCodeAt(0) - 65, A + iso.toUpperCase().charCodeAt(1) - 65);
    }
    function show(region, country, iso) {
      var loc = region ? region + ', ' + country : country;
      if (textEl) textEl.textContent = prefix + ' ' + loc;
      if (flagEl) flagEl.textContent = flagEmoji(iso);
    }
    function showFallback() {
      var country = bar.getAttribute('data-country');
      var iso = bar.getAttribute('data-iso');
      if (country) { show('', country, iso); }
      else if (textEl) { textEl.textContent = fallback; }
    }

    var timeout = setTimeout(showFallback, 4000);
    fetch('https://ipapi.co/json/')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        clearTimeout(timeout);
        if (d && d.country_name) { show(d.region || '', d.country_name, d.country_code || ''); }
        else { showFallback(); }
      })
      .catch(function() { clearTimeout(timeout); showFallback(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header = document.getElementById('elhdr');
  var menuBtn = document.getElementById('elhdr-menu-btn');
  var overlay = document.getElementById('elhdr-overlay');
  var drawer = document.getElementById('elhdr-drawer');
  var closeBtn = document.getElementById('elhdr-drawer-close');
  function openDrawer() { drawer.classList.add('open'); overlay.classList.add('show'); document.body.classList.add('no-scroll'); }
  function closeDrawer() { drawer.classList.remove('open'); overlay.classList.remove('show'); document.body.classList.remove('no-scroll'); }
  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  /* Sticky header on scroll (comme Uvola : >40px) */
  if (header) {
    var hH = header.offsetHeight;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) { header.classList.add('sticky'); document.body.style.paddingTop = hH + 'px'; }
      else { header.classList.remove('sticky'); document.body.style.paddingTop = ''; }
    }, { passive: true });
  }

  /* Cart icon opens the custom Elavie drawer (plomberie conservée) */
  var cartBtn = document.getElementById('elhdr-cart-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      if (typeof window.openCartDrawer === 'function') { e.preventDefault(); window.openCartDrawer(); }
    });
  }

  /* Close open loc dropdowns when clicking outside */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.eloc[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-home-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ehp__card').forEach(function(card) {
    var imgs = card.querySelectorAll('.ehp__image');
    var dots = card.querySelectorAll('.ehp__dot');
    if (!imgs.length) return;
    var current = 0;
    function show(i) {
      current = (i + imgs.length) % imgs.length;
      imgs.forEach(function(el, idx) { el.classList.toggle('is-active', idx === current); });
      dots.forEach(function(el, idx) { el.classList.toggle('is-active', idx === current); });
    }
    dots.forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        show(parseInt(this.getAttribute('data-i'), 10));
      });
    });
    /* hover → second image (Enerra hover-image-overlay behavior) */
    if (imgs.length > 1) {
      card.addEventListener('mouseenter', function() { if (current === 0) show(1); });
      card.addEventListener('mouseleave', function() { show(0); });
      /* touch swipe */
      var startX = 0, startY = 0;
      var container = card.querySelector('.ehp__image-container');
      if (container) {
        container.addEventListener('touchstart', function(e) {
          var t = e.changedTouches[0]; startX = t.clientX; startY = t.clientY;
        }, { passive: true });
        container.addEventListener('touchend', function(e) {
          var t = e.changedTouches[0];
          var dx = t.clientX - startX, dy = t.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(dx < 0 ? current + 1 : current - 1); }
        }, { passive: true });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  var gallery = document.getElementById("pdp-gallery");
  if (gallery) {
    var media = gallery.querySelector(".pdp__main-media");
    var thumbs = gallery.querySelectorAll(".pdp__thumb");
    var slides = media ? media.querySelectorAll(".swiper-slide") : [];
    /* The bundle slide (#pdp-bar-slide) sits at Swiper index 0 with no dot of its own:
       dots map to slide index + offset, and the bundle slide lights no dot. */
    var barOffset = document.getElementById("pdp-bar-slide") ? 1 : 0;
    function syncThumbs(i) {
      /* Uvola-style dots on mobile: a fixed window of 6 dots that slides with the
         active slide (active highlighted, window edges slightly smaller). */
      i = i - barOffset;
      var WIN = 6, total = thumbs.length;
      var start = total <= WIN ? 0 : Math.max(0, Math.min(i - 2, total - WIN));
      thumbs.forEach(function(el, idx) {
        var inWin = idx >= start && idx < start + WIN;
        el.classList.toggle("is-active", idx === i);
        el.classList.toggle("pdp__thumb--rim", !inWin);
        el.classList.toggle("pdp__thumb--edge", inWin && total > WIN && (idx === start || idx === start + WIN - 1));
      });
    }
    function initGallery() {
      if (!media || slides.length < 2) return; /* single image: nothing to slide */
      if (typeof Swiper === "undefined") { return setTimeout(initGallery, 120); }
      /* Safety net: kill native image drag inside the gallery (it cancels Swiper's pointer tracking) */
      media.addEventListener("dragstart", function (e) { e.preventDefault(); });
      /* Uvola product-offer gallery: peek next slide on mobile (1.15), full slide on desktop.
         Swiper only decodes the active + adjacent slides; the rest stay loading="lazy" (no mobile freeze). */
      var sw = new Swiper(media, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        grabCursor: true,
        threshold: 5,
        breakpoints: { 981: { slidesPerView: 1, spaceBetween: 0 } },
        navigation: { prevEl: "#pdp-prev", nextEl: "#pdp-next" },
        on: {
          init: function () { syncThumbs(this.activeIndex); },
          slideChange: function () { syncThumbs(this.activeIndex); }
        }
      });
      thumbs.forEach(function(t) {
        t.addEventListener("click", function() { sw.slideTo(parseInt(this.getAttribute("data-i"), 10) + barOffset); });
      });
    }
    initGallery();
  }

  /* ATC — AJAX add, open custom drawer (fallback /cart) */
  var form = document.getElementById("pdp-form");
  var variantIdEl = document.getElementById("pdp-variant-id");
  var atcBtn = document.getElementById("pdp-atc");
  var atcOriginal = atcBtn ? atcBtn.innerHTML : "";
  if (form) {
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      var id = variantIdEl ? variantIdEl.value : "";
      if (!id) { form.submit(); return; }
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = atcBtn.getAttribute("data-adding-label") || "Adding..."; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function(r) { return r.json(); }).then(function() {
        if (atcBtn) { atcBtn.innerHTML = atcOriginal; atcBtn.disabled = false; }
        document.dispatchEvent(new CustomEvent("cart:updated"));
        if (typeof window.openCartDrawer === "function") { window.openCartDrawer(); return; }
        window.location.href = "/cart";
      }).catch(function() { form.submit(); });
    });
  }

  /* Uvola-style priced ATC button. Kaching only injects the discounted total into
     our theme button; we render "TEXT | price compare" ourselves from the selected
     bundle bar (price + struck full price) and keep it in sync on selection change.
     Money path (form submit / drawer) untouched. */
  (function () {
    var btn = document.getElementById("pdp-atc");
    if (!btn || !window.MutationObserver) return;
    var textSpan = btn.querySelector(".pdp__atc-text");
    if (!textSpan) return;
    function selData() {
      var sel = document.querySelector(".kaching-bundles__bar--selected");
      if (!sel) return null;
      var priceEl = sel.querySelector(".kaching-bundles__bar-price");
      var fullEl = sel.querySelector(".kaching-bundles__bar-full-price");
      var price = priceEl ? (priceEl.textContent || "").trim() : "";
      var full = fullEl ? (fullEl.textContent || "").trim() : "";
      if (!price) return null;
      return { price: price, compare: (full && full !== price) ? full : "" };
    }
    function after(ref, cls, txt) {
      var el = btn.querySelector("." + cls);
      if (!el) {
        el = document.createElement("span");
        el.className = cls;
        if (txt != null) el.textContent = txt;
        ref.insertAdjacentElement("afterend", el);
      }
      return el;
    }
    function sync() {
      var d = selData();
      var div = btn.querySelector(".pdp__atc-divider");
      var pr = btn.querySelector(".pdp__atc-price");
      var cmp = btn.querySelector(".pdp__atc-compare");
      if (!d) {
        if (div) div.remove(); if (pr) pr.remove(); if (cmp) cmp.remove();
        return;
      }
      div = after(textSpan, "pdp__atc-divider", "|");
      pr = after(div, "pdp__atc-price");
      if (pr.textContent !== d.price) pr.textContent = d.price;
      if (d.compare) {
        cmp = after(pr, "pdp__atc-compare");
        if (cmp.textContent !== d.compare) cmp.textContent = d.compare;
      } else if (cmp) {
        cmp.remove();
      }
    }
    var raf = null;
    function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; sync(); }); }
    new MutationObserver(schedule).observe(document.body, {
      subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["class"]
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".kaching-bundles__bar-container, .kaching-bundles__bar")) {
        setTimeout(sync, 60);
      }
    }, true);
    var n = 0, iv = setInterval(function () { sync(); if (++n > 40) clearInterval(iv); }, 250);
    sync();
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.getElementById('elavie-sticky');
  if (!bar) return;
  var buybox = document.querySelector('.pdp');

  function scrollToBuybox() {
    if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  var btn = document.getElementById('elavie-sticky-btn');
  if (btn) btn.addEventListener('click', scrollToBuybox);

  function drawerOpen() {
    return !!document.querySelector('.elcd.is-open, .elcd[open], #cart-drawer[open], cart-drawer[open], .drawer.active');
  }
  var ticking = false;
  function check() {
    var doc = document.documentElement;
    var denom = doc.scrollHeight - window.innerHeight;
    var pct = denom > 0 ? (window.scrollY / denom) * 100 : 0;
    if (pct >= 20 && !drawerOpen()) { bar.classList.add('is-visible'); }
    else { bar.classList.remove('is-visible'); }
    ticking = false;
  }
  window.addEventListener('scroll', function() {
    if (!ticking) { ticking = true; setTimeout(check, 50); }
  }, { passive: true });
  setTimeout(check, 500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* UGC videos: only poster images exist at load. Players are built ONE AT A TIME
     (several decoders at once froze mobile scroll), and only once the page has
     fully loaded AND the user made a first gesture. */
  var posters = [].slice.call(document.querySelectorAll(".euv__poster[data-video-src]"));
  if (!posters.length || !("IntersectionObserver" in window)) return;
  var queue = [];
  var building = false;
  var players = [];
  var ICON_MUTED = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
  var setMuted = function(entry, muted) {
    entry.video.muted = muted;
    entry.btn.innerHTML = muted ? ICON_MUTED : ICON_SOUND;
  };
  var buildNext = function() {
    if (building || !queue.length) return;
    building = true;
    var img = queue.shift();
    if (img.__built) { building = false; buildNext(); return; }
    img.__built = true;
    var thumb = img.parentNode;
    var v = document.createElement("video");
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute("playsinline", "");
    v.preload = "metadata";
    v.poster = img.src;
    v.src = img.getAttribute("data-video-src");
    v.style.cssText = "width:100%;height:100%;object-fit:cover;display:block;";
    var done = false;
    var release = function() {
      if (done) return; done = true;
      building = false;
      setTimeout(buildNext, 300);
    };
    v.addEventListener("canplay", release, { once: true });
    setTimeout(release, 2500);
    img.replaceWith(v);
    /* Sound toggle button (exact Enerra) — unmuting one tile mutes the others */
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "euv__sound";
    var strip = thumb ? thumb.closest(".euv__strip") : null;
    btn.setAttribute("aria-label", (strip && strip.getAttribute("data-sound-label")) || "Toggle sound");
    btn.innerHTML = ICON_MUTED;
    var entry = { video: v, btn: btn };
    players.push(entry);
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      var wasMuted = v.muted;
      players.forEach(function(other) { setMuted(other, true); });
      if (wasMuted) {
        setMuted(entry, false);
        var pp = v.play(); if (pp && pp.catch) pp.catch(function() {});
      }
    });
    if (thumb) thumb.appendChild(btn);
    var p = v.play(); if (p && p.catch) p.catch(function() {});
  };
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting && !e.target.__queued) {
        e.target.__queued = true;
        queue.push(e.target);
        io.unobserve(e.target);
        buildNext();
      }
    });
  }, { rootMargin: "50px", threshold: 0.1 });
  var armed = false;
  var loaded = document.readyState === "complete";
  var gestured = false;
  var arm = function() {
    if (armed || !loaded || !gestured) return;
    armed = true;
    posters.forEach(function(img) { io.observe(img); });
  };
  if (!loaded) {
    window.addEventListener("load", function() { loaded = true; arm(); }, { once: true });
    setTimeout(function() { loaded = true; arm(); }, 7000);
  }
  var onGesture = function() { gestured = true; arm(); };
  ["touchstart", "scroll", "wheel", "mousemove", "keydown"].forEach(function(evt) {
    window.addEventListener(evt, onGesture, { once: true, passive: true });
  });
  setTimeout(function() { gestured = true; arm(); }, 10000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
